import React from 'react';
import './ComparisonTable.css';

const ComparisonTable = ({ title, columns, rows, highlight = null }) => {
  return (
    <div className="comparison-table-container">
      {title && <h3 className="comparison-table-title">{title}</h3>}
      <div className="comparison-table-wrapper">
        <table className="comparison-table">
          <thead>
            <tr>
              <th className="feature-column">Feature</th>
              {columns.map((column, index) => (
                <th key={index} className={index === 0 ? 'primary-column' : ''}>
                  {column}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, rowIndex) => (
              <tr key={rowIndex} className={highlight === row.feature ? 'highlighted-row' : ''}>
                <td className="feature-cell">
                  <strong>{row.feature}</strong>
                </td>
                {row.values.map((value, valueIndex) => (
                  <td key={valueIndex} className={valueIndex === 0 ? 'primary-value' : ''}>
                    {value}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ComparisonTable;
